import { FontAwesome5 } from '@expo/vector-icons';
import * as React from 'react';

import { EllipseIcon } from '../../../templates/ellipse-icon/ellipse-icon';
import { EmojiDivider } from '../emoji-divider/emoji-divider';

export const CheckEmojiDivider = () => {
  return (
    <EmojiDivider
      emoji={
        <EllipseIcon iconSize={32}>
          <FontAwesome5 name="check" size={32} />
        </EllipseIcon>
      }
    />
  );
};
